import { render, staticRenderFns } from "./VToolbar.vue?vue&type=template&id=d983b4de&scoped=true&"
import script from "./VToolbar.vue?vue&type=script&lang=js&"
export * from "./VToolbar.vue?vue&type=script&lang=js&"
import style0 from "./VToolbar.vue?vue&type=style&index=0&id=d983b4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d983b4de",
  null
  
)

export default component.exports